import appService from 'src/pl.service';
import { statuses } from 'src/constants/statuses';
import { RUN_DEMOGRAPHICS_TEST } from 'src/store/actions/types';

/**
 * runs the demographics test for the given applicant, falling back to the
 * applicant currently in the store
 */
export const runDemographicsTest = async ({ commit, state }, applicantId) => {
  try {
    commit(RUN_DEMOGRAPHICS_TEST, {
      status: statuses.pending,
    });
    await appService.runDemographics(applicantId ?? state.applicant.id);
    commit(RUN_DEMOGRAPHICS_TEST, {
      status: statuses.success,
    });
  } catch (error) {
    commit(RUN_DEMOGRAPHICS_TEST, {
      status: statuses.failure,
      error,
    });
  }
};
